import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

const BRAND = { color: '#1e3a5f' };

const LoginPage = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: `linear-gradient(135deg, ${BRAND.color} 0%, #0f2440 100%)` }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <Card className="p-8 border-slate-200 shadow-xl" data-testid="login-card">
          <div className="flex items-center justify-center gap-2.5 mb-8">
            <img src="/macropago-logo.jpeg" alt="MacroPago" className="w-12 h-12 rounded-lg object-cover" />
            <span className="text-2xl font-bold" style={{ color: BRAND.color, fontFamily: 'Manrope' }}>MacroPago</span>
          </div>

          <h1 className="text-2xl font-bold text-slate-900 mb-2 text-center" style={{ fontFamily: 'Manrope' }}>Iniciar Sesion</h1>
          <p className="text-slate-600 text-center mb-8 text-sm">Accede con tu cuenta de Google</p>

          <Button
            data-testid="google-login-button"
            onClick={handleGoogleLogin}
            className="w-full bg-white text-slate-900 border-2 border-slate-200 hover:bg-slate-50 h-12 font-semibold flex items-center justify-center gap-3"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </Button>

          <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-xs text-blue-800 text-center">
              <strong>Nota:</strong> Solo emails autorizados pueden acceder al sistema. Contacta al administrador si necesitas acceso.
            </p>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-slate-600">
              Sos cliente?{' '}
              <button onClick={() => navigate('/debtor/search')} className="font-semibold hover:underline" style={{ color: BRAND.color }}>
                Consulta tu deuda aca
              </button>
            </p>
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default LoginPage;
